const MAIN_UNIT_ACTIVITY_TYPES = new Set([
  "risk",
  "simulacrum",
  "operational_procedure",
]);

const ACTIVITY_TYPE_ALIASES = {
  "planning.evaluacion_riesgo": "risk",
  "planning.ejercicio_operativo": "operational_procedure",
  "planning.simulacro": "simulacrum",
  "evaluacion de riesgo": "risk",
  "ejercicio operativo": "operational_procedure",
  simulacro: "simulacrum",
};

function normalizeActivityType(activityType) {
  if (activityType == null) return "";
  return String(activityType)
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ");
}

function resolveActivityTypeSlug(activityType) {
  const normalizedActivityType = normalizeActivityType(activityType);
  if (!normalizedActivityType) return "";
  if (MAIN_UNIT_ACTIVITY_TYPES.has(normalizedActivityType)) {
    return normalizedActivityType;
  }
  return ACTIVITY_TYPE_ALIASES[normalizedActivityType] || "";
}

function getMainUnitValue(unit) {
  if (!unit || typeof unit !== "object") return undefined;
  const candidates = [
    unit.is_main_unit,
    unit.unit && unit.unit.is_main_unit,
    unit.unit_id && typeof unit.unit_id === "object" && unit.unit_id.is_main_unit,
  ];
  return candidates.find((value) => value !== undefined && value !== null);
}

export function shouldFilterMainUnitsByActivityType(activityType) {
  const slug = resolveActivityTypeSlug(activityType);
  if (!slug) return false;
  return MAIN_UNIT_ACTIVITY_TYPES.has(slug);
}

export function isMainUnit(unit) {
  const value = getMainUnitValue(unit);
  return value === 1 || value === true || value === "1";
}

export function hasMainUnitFlag(unit) {
  const value = getMainUnitValue(unit);
  return value !== undefined && value !== null;
}

export function filterMainUnitsIfPresent(units) {
  if (!Array.isArray(units)) return [];
  const hasMainUnitField = units.some((unit) => hasMainUnitFlag(unit));
  if (!hasMainUnitField) return units;
  return units.filter(isMainUnit);
}
